import { useEffect } from 'react'
import { SITE_URL } from './seoRoutes'

function upsertMeta(attr, key, content) {
  if (!content) return
  let tag = document.head.querySelector(`meta[${attr}="${key}"]`)
  if (!tag) {
    tag = document.createElement('meta')
    tag.setAttribute(attr, key)
    document.head.appendChild(tag)
  }
  tag.setAttribute('content', content)
}

function upsertCanonical(pathname) {
  const canonicalHref = `${SITE_URL}${pathname}`
  let link = document.head.querySelector('link[rel="canonical"]')
  if (!link) {
    link = document.createElement('link')
    link.setAttribute('rel', 'canonical')
    document.head.appendChild(link)
  }
  link.setAttribute('href', canonicalHref)
}

function writeJsonLd(payload) {
  const existing = document.getElementById('dynamic-jsonld')
  if (existing) existing.remove()
  if (!payload) return

  const script = document.createElement('script')
  script.id = 'dynamic-jsonld'
  script.type = 'application/ld+json'
  script.text = JSON.stringify(payload)
  document.head.appendChild(script)
}

export function usePageSeo({
  title,
  description,
  keywords,
  pathname,
  robots = 'index, follow',
  image = `${SITE_URL}/og-image.png`,
  jsonLd,
}) {
  useEffect(() => {
    if (title) document.title = title

    upsertMeta('name', 'description', description)
    upsertMeta('name', 'keywords', keywords)
    upsertMeta('name', 'robots', robots)

    upsertMeta('property', 'og:type', 'website')
    upsertMeta('property', 'og:site_name', 'Co-Eater')
    upsertMeta('property', 'og:title', title)
    upsertMeta('property', 'og:description', description)
    upsertMeta('property', 'og:url', `${SITE_URL}${pathname}`)
    upsertMeta('property', 'og:image', image)

    upsertMeta('name', 'twitter:card', 'summary_large_image')
    upsertMeta('name', 'twitter:title', title)
    upsertMeta('name', 'twitter:description', description)
    upsertMeta('name', 'twitter:image', image)

    upsertCanonical(pathname)
    writeJsonLd(jsonLd)

    return () => {
      const existing = document.getElementById('dynamic-jsonld')
      if (existing) existing.remove()
    }
  }, [title, description, keywords, pathname, robots, image, jsonLd])
}
